module.exports = __webpack_public_path__ + "img/5-中铁建幕墙.68509fe8.jpg";